import Vue from "vue";
import Vuex from "vuex";

import app from "~/store/app";
import cart from "~/store/cart";
import category from "~/store/category";
import wordsSearched from "~/store/wordsSearched";

import VuexPersistence from "vuex-persist";
import createLogger from "vuex/dist/logger";

console.log(
  "debug",
  process.env.NODE_ENV,
  process.env.NODE_ENV !== "production"
);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ["app", "wordsSearched"],
  reducer: state => ({
    app: {
      drawerLeft: state.app.drawerLeft,
      lastStartTime: state.app.lastStartTime,
      lastTutorialSeen: state.app.lastTutorialSeen,
      firstShopTime: state.app.firstShopTime,
      cookiePreferences: state.app.cookiePreferences,
      ordersSentToAnalytics: state.app.ordersSentToAnalytics,
      reopenCookies: state.app.reopenCookies
    },
    wordsSearched: state.wordsSearched
  }),
  filter: mutation =>
    mutation.type != "app/increasePendingRequests" ||
    mutation.type == "app/decreasePendingRequests"
});
const vuexSession = new VuexPersistence({
  storage: window.sessionStorage,
  modules: ["category", "cart"],
  reducer: state => ({
    category: {
      category: state.category.category,
      filters: state.category.filters
    }
  })
});
const modules = {
  modules: {
    app,
    cart,
    category,
    wordsSearched
  },
  strict: process.env.NODE_ENV !== "production",
  plugins:
    process.env.NODE_ENV !== "production"
      ? [createLogger(), vuexLocal.plugin, vuexSession.plugin]
      : [vuexLocal.plugin, vuexSession.plugin]
};

Vue.use(Vuex);
const store = new Vuex.Store(modules);
export default store;
